import { MedicationFrequencyEnum } from "requests";

export const FREQUENCY_TO_TITLE = {
  [MedicationFrequencyEnum.Prn]: "PRN",
  [MedicationFrequencyEnum.Hr_2]: "2 hrs",
  [MedicationFrequencyEnum.Hr_4]: "4 hrs",
  [MedicationFrequencyEnum.Hr_6]: "6 hrs",
  [MedicationFrequencyEnum.Hr_8]: "8 hrs",
  [MedicationFrequencyEnum.Hr_10]: "10 hrs",
  [MedicationFrequencyEnum.Hr_12]: "12 hrs",
  [MedicationFrequencyEnum.Hr_14]: "14 hrs",
  [MedicationFrequencyEnum.Hr_16]: "16 hrs",
  [MedicationFrequencyEnum.Hr_18]: "18 hrs",
  [MedicationFrequencyEnum.Hr_20]: "20 hrs",
  [MedicationFrequencyEnum.Hr_22]: "22 hrs",
  [MedicationFrequencyEnum.Hr_24]: "24 hrs"
};
